import chipseq from "@/data/documentation/chipseq";
import rawDataQc from "@/data/documentation/rawDataQc";
import variantAnalysis from "@/data/documentation/variantAnalysis";
import transcriptomeResequencing from "@/data/documentation/transcriptomeResequencing";
import exome from "@/data/documentation/exome";
import metagenome from "@/data/documentation/metagenome";

export default function DocumentationPanel({
    moduleKey,
    step,
}) {

    const documentation = {
        "chipseq": chipseq,
        "raw-data-qc": rawDataQc,
        "variant-analysis": variantAnalysis,
        "transcriptome": transcriptomeResequencing,
        "exome-targeted": exome,
        metagenome,
    };

    const doc = documentation[moduleKey];

    return (
        <div className="rounded-xl border border-[#D7E7D1] bg-[#F8FBF7] shadow-sm overflow-hidden">

            {/* Header */}
            <div className="bg-[#0B6936] px-5 py-4 text-white">
                <h3 className="text-lg font-semibold">
                    {doc?.title || "Documentation"}
                </h3>
            </div>

            {/* Content */}
            <div className="max-h-[calc(100vh-160px)] overflow-y-auto p-5 space-y-8">

                {doc ? (
                    doc.fields.map((field, index) => (
                        <div
                            key={index}
                            className="rounded-lg border border-gray-200 bg-white p-5"
                        >
                            <h3 className="text-lg font-semibold text-[#0B6936]">
                                {field.title}
                            </h3>

                            <p className="mt-2 text-sm leading-7 text-gray-700">
                                {field.description}
                            </p>

                            {field.examples?.length > 0 && (
                                <>
                                    <h4 className="mt-4 text-sm font-semibold text-gray-900">
                                        Examples
                                    </h4>

                                    <ul className="mt-2 list-disc pl-5 text-sm text-gray-600">
                                        {field.examples.map((example) => (
                                            <li key={example}>{example}</li>
                                        ))}
                                    </ul>
                                </>
                            )}

                            {field.sections?.length > 0 && (
                                <div className="mt-5 space-y-5">
                                    {field.sections.map((section) => (
                                        <div
                                            key={section.title}
                                            className="rounded-md border border-gray-100 bg-gray-50 p-4"
                                        >
                                            <h4 className="text-sm font-semibold text-[#0B6936]">
                                                {section.title}
                                            </h4>

                                            <p className="mt-2 text-sm leading-6 text-gray-700">
                                                {section.description}
                                            </p>

                                            {section.notes?.length > 0 && (
                                                <ul className="mt-3 list-disc pl-5 text-sm text-gray-600 space-y-1">
                                                    {section.notes.map((note) => (
                                                        <li key={note}>{note}</li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {field.notes?.length > 0 && (
                                <>
                                    <h4 className="mt-4 text-sm font-semibold text-gray-900">
                                        Notes
                                    </h4>

                                    <ul className="mt-2 list-disc pl-5 text-sm text-gray-600">
                                        {field.notes.map((note) => (
                                            <li key={note}>{note}</li>
                                        ))}
                                    </ul>
                                </>
                            )}
                        </div>
                    ))
                ) : (
                    <div className="text-center py-12 text-gray-500">
                        Documentation is not yet available for this module.
                    </div>
                )}

            </div>

        </div>
    );
}